module.exports = __webpack_public_path__ + "img/visa-card.5c987393.png";